<div class="mt-5 flex justify-center mr-[30px]">
  <div class="main-section  flex flex-col justify-between w-[100%]">
   
    <div class="bg-white w-[100%]">
      <div
        class=" flex card-container shadow-custom m-[22px] mt-0 ml-[10px] bg-[#ffffff] rounded-lg"
      >
      <div class="w-[0%] !mt-[23px] flex justify-start items-start mr-[40px]">
        <button (click)="handleClose()" class="hover:bg-[#DEE2E6] rounded-full mr-[0.5rem]">
          <mat-icon class="!h-[1rem]">chevron_left</mat-icon>
        </button>
      </div> 
        <table class="w-full table-auto table-striped mt-[10px]">
          
          <thead>
            <tr  class="bg-[#DEE2E6]">
              <th class="w-1/4 !pl-[2rem]">
                <div class="flex justify-start items-center design-header">
                  Versions
                </div>
              </th>

              <th class="w-1/4 pl-10">
                <div class="flex justify-center items-center design-header pr-[1.2rem]">
                  Date Modified
                </div>
              </th>
              <th class="w-1/4 !pr-[2rem]">
                <div class="flex justify-end items-center design-header">
                  Modified by
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                class="!text-start !text-[16.5px] text-nowrap !pl-[2rem]"
                style="display: flex; justify-content: start"
                (click)="navigateToLatestVersionViewMode()"
              >
                <img
                  src="assets/icons/Folder-Icon.svg"
                  alt="folder icon"
                  class="mr-[11px]"
                />
                Latest Version
              </td>
              <td class="!text-center !text-[16.5px]">
                {{
                  latestVersion["updated_at"] | date : "MM/dd/yyyy, hh:mm:ss a"
                }}
              </td>
              <td class="!text-end !text-[16.5px] !pr-[2rem]">
                {{
                  latestVersion["created_by"] &&
                  latestVersion["created_by"]["email"]
                    ? latestVersion["created_by"]["email"]
                    : "System Generated"
                }}
              </td>
            </tr>
            <tr *ngFor="let revision of revisions; let i = index">
              <td
                class="!text-start !text-[16.5px] text-nowrap !pl-[2rem]"
                style="display: flex; justify-content: start"
                (click)="navigateToOldVersionViewMode(revision?.id)"
              >
                <img
                  src="assets/icons/Folder-Icon.svg"
                  alt="folder icon"
                  class="mr-[11px]"
                />
                {{ revision.version }}
                <span class="text-[13px] font-normal underline ml-2">Old</span>
              </td>

              <td class="!text-center !text-[16.5px]">
                {{ revision.dateModified | date : "MM/dd/yyyy hh:mm:ss a" }}
              </td>
              <td class="!text-end !text-[16.5px] !pr-[2rem]">
                {{ revision.modifiedBy }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
